import { render, staticRenderFns } from "./DashSettledCasesList.vue?vue&type=template&id=ea016c4a&scoped=true&"
import script from "./DashSettledCasesList.vue?vue&type=script&lang=js&"
export * from "./DashSettledCasesList.vue?vue&type=script&lang=js&"
import style0 from "./DashSettledCasesList.vue?vue&type=style&index=0&id=ea016c4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea016c4a",
  null
  
)

export default component.exports